import { Avatar, Icons, TopBar, useToasts } from "@osttra/ds-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { postData } from "../../api/fetch.service.api";
import { logoutUrl } from "../../constants/Constants";
import logo from "../../images/logo.png";
import { getErrorMessage } from "../../utils/Utils";

const Header = ({ userMail }: { userMail: string }) => {
  const navigate = useNavigate();
  const addToast = useToasts();
  const userIDSplit = userMail?.split("@");
  const userNameSelect = userIDSplit[0].split(".");
  const firstName = userNameSelect[0];
  const secName = userNameSelect[1] ? userNameSelect[1] : "";
  const firstNameFistChar = firstName?.charAt(0).toUpperCase();
  const lastNameFistChar = secName?.charAt(0).toUpperCase();

  const logout = async (e?: React.MouseEvent<HTMLAnchorElement>) => {
    e?.preventDefault();
    try {
      await postData({ url: logoutUrl, body: {} });
      localStorage.removeItem("isSamlLogin");
      navigate("/saml/login", { replace: true });
    } catch (err) {
      addToast("error", getErrorMessage(err));
    }
  };

  return (
    <TopBar
      logo={<TopBar.Logo image={logo} />}
      appSwitcher={
        <TopBar.AppSwitcher>
          <div className="t-menu t-is-open t-menu-right">
            <div className="t-group">
              <a className="t-item" href="https://osttra.com/" target="_blank" rel="noopener noreferrer">
                osttra.com
              </a>
            </div>
          </div>
        </TopBar.AppSwitcher>
      }
      menuRight={
        <TopBar.DropDown
          avatar={<Avatar initials={`${firstNameFistChar}${lastNameFistChar}`} />}
          id="account-settings"
          subTitle="OSTTRA"
          title={firstName + " " + secName}
        >
          <div className="t-menu t-menu-right t-is-open">
            <a className="t-item" href="/saml/login" onClick={logout}>
              <Icons.SignOut />
              Log Out
            </a>
          </div>
        </TopBar.DropDown>
      }
    />
  );
};

export default Header;
